const loopHelper = data => {
  if (typeof data === 'string') {
    return data
  }
  if (data[0] && data[0].message) {
    return data[0].message
  }

  for (let key in data) {
    if (!Object.prototype.hasOwnProperty.call(data, key)) {
      continue
    }

    return typeof data[key] === 'string' ? data[key] : data[key][0]
  }
}

export const errHandler = ({ response, status, data }) => {
  if (response) {
    data = response.data
    status = response.status
  }
  let error = ''

  if ([400, 422].includes(status) && data) {
    if (typeof data === 'string') {
      error = data
    } else if (data[0] && data[0].message) {
      error = loopHelper(data[0].message)
    } else if (data.errors) {
      error = loopHelper(data.errors)
    }
  }

  return error ? error : 'Неизвестная ошибка'
}
